import React, { lazy, Suspense } from "react";
import type { ComponentType, ReactNode } from "react";

type Loaded<P> = ComponentType<P> | { default: ComponentType<P> };
type DynamicOptions = {
  ssr?: boolean;
  loading?: (state: { isLoading: boolean; error: Error | null; pastDelay: boolean }) => ReactNode;
};

/** Substituto do next/dynamic sobre React.lazy + Suspense. */
export default function dynamic<P extends object>(
  loader: () => Promise<Loaded<P>>,
  options: DynamicOptions = {},
): ComponentType<P> {
  const LazyComponent = lazy(async () => {
    const loaded = await loader();
    return typeof loaded === "object" && loaded !== null && "default" in loaded ? loaded : { default: loaded };
  });
  const fallback = options.loading?.({ isLoading: true, error: null, pastDelay: true }) ?? null;

  function DynamicComponent(props: P) {
    return (
      <Suspense fallback={fallback}>
        <LazyComponent {...props} />
      </Suspense>
    );
  }
  return DynamicComponent;
}
